import { observable, action, computed } from 'mobx';
import * as DashboardService from 'services/DashboardService';
import * as HomeService from 'services/HomeService';
import * as ShareService from 'services/ShareService';
import * as TextService from 'services/TextService';
import * as TeamInfoService from 'services/TeamInfoService';
// import openTeamStore from 'stores/OpenTeamStore';
import { hashHistory } from 'react-router';
window.hashHistory = hashHistory;
import activityMeta from 'utils/activityMeta';
import { toast } from 'utils/notification';
import { transformNumber, transformString, ransformArray } from 'utils/transformType';
const { Account, Time } = window.$ACE;

const getQuery = () => {
  return hashHistory.getCurrentLocation().query;
};

/**
 * 基本信息Store
 */
class DashboardStore {
  @observable
  isLogin = false; // 是否登录
  @observable
  isNewUser = false; // 是否为新用户
  @observable
  channel = 'N'; // 分享渠道
  @observable
  shareType = 'N'; // 分享类型
  @observable
  userCode = ''; // 当前登录用户的云大使Code
  @observable
  groupCode = null; // 当前登录用户的参加的团或者开的团Code
  @observable
  shareUserCode = ''; // 当前URL里的用户Code，如果没有则为空
  @observable
  shareGroupCode = ''; // 当前URL里的团Code，如果没有则为空
  @observable
  Activitystate = activityMeta.activityState.start; // 判断活动当前的状态
  @observable
  activityRule = null; //活动规则
  @observable
  pcActivityRule = null; //PC活动规则
  @observable
  h5DiscountRule = null; // h5折扣规则
  @observable
  dashiRule = null; // 阿里云云大使介绍
  @observable
  ruleWithoutPacket = null; // 没有红包和返佣的规则介绍

  @observable
  groupRuleH5 = null; //=>H5攻略图标提示攻略

  // 团信息
  @observable
  totalPayCount = 0; // 团新购人数
  @observable
  myPayCount = 0; // 我的拉新人数
  @observable
  myPrize = 0; // 个人预计可瓜分金额
  @observable
  currentRank = 0; // 当前团排名信息
  @observable
  frontMembers = '';
  @observable
  frontPrize = '';
  @observable
  nick = '-'; // 团昵称
  @observable
  icon = ''; // 团头像
  // @observable
  // discount = '-'; // 团折扣力度
  @observable
  refundAmount = 0; //返还金额

  @observable
  totalPrize = 0; //团预计瓜分金额

  @observable
  originalAmount = 0; // 原价

  @observable
  pageInfo = {
    currentPage: 1,
    pageSize: 6,
    totalCount: 1,
  };

  @observable
  leader = 0;

  @observable
  groupMembers = []; // 团成员

  @observable
  specName = ''; //产品名称

  @observable
  leagueList = []; //团战pktable

  @observable
  tradeAmount = 0; //购买价格

  @observable
  packetCount = 0; //未领取红包数

  @observable
  packetAmount = 0; //已领券红包金额

  @observable
  myPackageList = []; //我的待領取紅包列表

  @observable
  currentPackageCount = '0'; //當前獲取紅包的價格

  @observable
  showReceiveRedPackage = false; //是否顯示彈窗

  @observable
  ActivityTime = ''; //确定是13号揭榜期间还是活动真的结束了,控制h5活动时间的显示隐藏和13号揭榜期
  @observable
  msgList = []; // 留言板消息
  // 倒计时
  @observable
  Countdown = {
    days: '11',
    hours: '11',
    minutes: '11',
    seconds: '11',
  }; // 倒计时

  @observable
  loading = true; // 初始化状态

  @computed
  get isPackageShow() {
    return this.packetCount > 0;
  }

  @computed
  get isPackageAmount() {
    return this.packetAmount > 0;
  }

  //团折扣力度
  @computed
  get discount() {
    const totalPayCount = Number(this.totalPayCount);
    if (totalPayCount > 0) {
      if (totalPayCount < 6) {
        // return `折上${10 - totalPayCount}折`;
        return (
          <span>
            折上
            <span style={{ fontSize: '24px' }}>{10 - totalPayCount}</span>折
          </span>
        );
      }
      return (
        <span>
          折上
          <span style={{ fontSize: '24px' }}>5</span>折
        </span>
      );
    }
    return '—';
  }

  // 判断是不是组团期
  @computed
  get isInStart() {
    return this.Activitystate == 'start';
  }

  // 判断是不是组团期
  @computed
  get isEnd() {
    return this.Activitystate == 'end';
  }

  //是否展示解散团
  @computed
  get isShowDisbandingGroup() {
    return this.leader === 1 && this.groupMembers.length < 2 && this.totalPayCount < 1;
  }
  // 是否属于某个团
  @computed
  get belongTeam() {
    return this.groupCode != null;
  }
  // 分享URL的生成规则：分享类型.当前用户团队Code.当前用户云大使Code（可选）
  @computed
  get shareUrl() {
    const url = `${location.origin}${location.pathname}#/share?params=${this.shareType}.${this.groupCode}.${
      this.userCode ? this.userCode : ''
    }`;
    return url;
  }
  @computed
  get isIndex() {
    return hashHistory.getCurrentLocation().pathname == '/';
  }
  @computed
  get isShare() {
    return hashHistory.getCurrentLocation().pathname == '/share';
  }
  @computed
  get isSelf() {
    return hashHistory.getCurrentLocation().pathname == '/self';
  }

  @computed
  get isShowActivityEnd() {
    return this.Activitystate == 'end' && this.groupCode;
  }

  @computed
  get isPurchasedProduct() {
    return this.specName.length > 0;
  }

  @computed
  get isReceiveActivityRule() {
    return this.activityRule !== null;
  }
  @computed
  get isReceivePCActivityRule() {
    return this.pcActivityRule !== null;
  }
  @observable
  checkAmbassador = 1;
  @computed
  get hasApplied() {
    return this.checkAmbassador == 0;
  }
  @computed
  get canApply() {
    return this.checkAmbassador == 1;
  }
  @computed
  get canNotApply() {
    return this.checkAmbassador == 2;
  }
  // 根据获取URL里的分享信息以及用户的登录状态，来决定展示哪一个页面
  init = async () => {
    Time.countdown({
      targetTime: activityMeta.endRegiment,
      tick: leftTimes => {
        this.Countdown = leftTimes;
      },
      end: () => console.log('end'),
    });
    // 判断当前的活动状态
    const activityState = activityMeta.activityState;
    const isAfterCreateTime = await Time.isAfter(activityMeta.endCreate);
    const isAfterEndTime = await Time.isAfter(activityMeta.endRegiment);
    if (isAfterCreateTime) {
      if (isAfterEndTime) {
        this.Activitystate = activityState.end;
      } else {
        this.Activitystate = activityState.highTide;
      }
    } else {
      this.Activitystate = activityState.start;
    }
  };
  queryBaseData = async () => {
    this.parseUrl();
    const isLogin = await this.fetchLoginState();
    if (!isLogin) {
      //重定向
      this.redirect();
      this.loading = false;
      return false;
    }
    // 获取当前登录用户是否为新用户
    this.fetchUserState();
    // 获取当前登录的团信息
    const data = await this.fetchGroupInfo();
    // 云大使判断接口
    this.checkAccountForAmbassador();
    if (data) {
      this.setData(data);
    } else {
      this.groupInfoInit();
    }
    //重定向
    this.redirect();
    // if (this.Activitystate !== 'start' && this.isIndex) {
    //   await OpenTeamStore.leagueTable();
    // }
    this.loading = false;
    return true;
  };
  onDashBoardLoad = async () => {
    await this.queryBaseData();
  };
  backToHome = () => {
    hashHistory.push('/');
  };
  onSelfLoad = async () => {
    const isLogin = await this.queryBaseData();
    if (isLogin) {
      this.fetchMyPackageInfo();
      this.getGroupComments();
      const {
        pageInfo: { currentPage, pageSize },
        groupCode,
      } = this;
      this.queryGroupMembers({ currentPage, pageSize, groupCode });
    }
  };
  onShareLoad = async () => {
    await this.queryBaseData();
    this.getGroupInfo();
    // 发起打点请求
    if (window.$ACE) {
      window.$ACE.Tracker.record('/aliyun.share.spread', 'EXP', `channel=${this.channel}&type=${this.shareType}`);
    }
    // 微信分享
    TextService.fetchShareText().then(({ title, content, img }) => {
      if (window.$ACE) {
        const share = window.$ACE.Share.create({
          title,
          content,
          img,
        });
        share.wxShare();
      }
    });
    // 访问即关联
    setTimeout(() => {
      ShareService.shareBuildRelation(this.shareUserCode);
    }, 3000);
  };
  // 重定向
  redirect = () => {
    const activityState = activityMeta.activityState;
    if (this.isShare && this.Activitystate == activityState.end) {
      // 活动结束后，页面重定向到首页
      hashHistory.replace('/');
    }
    if (this.isShare) {
      if (!this.shareGroupCode) {
        // URL里不包含团Code，重定向到首页
        hashHistory.replace('/');
      }
    }
    if (this.isLogin) {
      // 已登录
      if (this.isSelf) {
        if (!this.groupCode) {
          // 未包含团信息，重定向到首页
          hashHistory.replace('/');
        }
      }
      if (this.isShare) {
        if (this.groupCode == this.shareGroupCode) {
          // 当前用户是该团成员，重定向到团战页
          hashHistory.replace('/self');
        }
      }
    } else if (this.isSelf) {
      // 未登录，重定向到首页
      hashHistory.replace('/');
    }
  };

  // 解析URL里的分享类型，分享团Code，分享者Code
  parseUrl = () => {
    const query = getQuery();
    const params = query.params;
    // 获取分享渠道
    this.channel = window.$ACE.Client.getChannel();
    if (params) {
      const [shareType, shareGroupCode, shareUserCode] = params.split('.');
      this.shareType = shareType;
      this.shareGroupCode = shareGroupCode;
      this.shareUserCode = shareUserCode;
    }
  };
  @action
  fetchLoginState = async () => {
    return Account.isLogin()
      .then(isLogin => {
        this.isLogin = isLogin;
        return isLogin;
      })
      .catch(err => {
        this.loading = false; // 未登录有兜底
        console.log(err);
      });
  };
  // 判断新老用户的接口
  @action
  fetchUserState = async () => {
    await DashboardService.judgeNewUsers('act801078798')
      .then(results => {
        if (results.code == 'VALIDATE_SUCCESS') {
          this.isNewUser = true;
        } else {
          this.isNewUser = false;
        }
      })
      .catch(err => {
        console.log(err);
      });
  };
  // 判断用户是否有资格成为云大使
  @action
  async checkAccountForAmbassador() {
    let results = await DashboardService.checkAccountForAmbassador();
    try {
      if (results.code == 200) {
        this.checkAmbassador = 1;
      } else if (results.code == 300) {
        this.checkAmbassador = 0;
        // 如果已经是云大使，再次获取云大使的userCode
        await this.fetchAmbassadorInfo();
      } else {
        this.checkAmbassador = 2;
      }
    } catch (err) {
      this.checkAmbassador = 2;
    }
  }
  // 获取留言板信息
  @action
  getGroupComments = async () => {
    let params = {
      groupCode: this.groupCode,
    };
    DashboardService.getGroupComments(params).then(results => {
      if (results.code == 200) {
        if (results.data) {
          let arr = results.data.map(item => {
            return {
              content: item.content,
              userName: item.userName,
              userHeadPic: item.userHeadPic,
              gmtCreate: item.gmtCreate,
            };
          });
          if (!window.isMobile) {
            arr.sort((val1, val2) => {
              return val1.gmtCreate - val2.gmtCreate;
            });
          }
          this.msgList = arr;
          if (!window.isMobile) {
            if ($('#msg-content')[0]) {
              $('#msg-content').scrollTop($('#msg-content')[0].scrollHeight);
            }
          }
        }
      }
    });
  };
  // 签约云大使
  @action
  async applyAmbassador() {
    let results = await DashboardService.applyAmbassador();
    if (results) {
      return results.code;
    }
  }

  /**
   * 获取云大使信息
   */
  @action
  fetchAmbassadorInfo = async () => {
    DashboardService.fetchAmbassadorInfo().then(results => {
      if (results.code == 200) {
        this.userCode = results.data.userCode;
        return null;
      } else {
        return results.code;
      }
    });
  };
  /**
   * @param {object} data 设置数据
   */
  @action
  setData = data => {
    this.groupCode = data.groupCode;
    this.totalPayCount = transformNumber(data.totalPayCount);
    this.myPayCount = transformNumber(data.myPayCount);
    this.myPrize = transformNumber(data.myPrize) / 100;
    this.leader = data.leader;
    this.refundAmount = transformNumber(data.refundAmount) / 100;
    this.currentRank = transformNumber(data.currentRank);
    this.nick = data.nick;
    this.icon = data.icon;
    this.frontMembers = data.frontMembers;
    this.frontPrize = transformNumber(data.frontPrize) / 100;
    this.totalPrize = transformNumber(data.totalPrize) / 100;
    this.specName = transformString(data.specName);
    this.tradeAmount = transformNumber(data.tradeAmount) / 100;
    this.totalPrize = transformNumber(data.totalPrize) / 100;
    this.packetCount = transformNumber(data.packetCount);
    this.packetAmount = transformNumber(data.packetAmount) / 100;
    this.originalAmount = transformNumber(data.originalAmount) / 100;
  };
  // 登录后查询团信息
  @action
  fetchGroupInfo = async () => {
    try {
      const { data = {}, code } = await DashboardService.fetchGroupInfo();
      if (code == 200) {
        return data;
      } else {
        return null;
      }
    } catch (error) {
      console.error(error);
    }
  };

  @action
  groupInfoInit = () => {
    this.groupCode = null;
    this.totalPayCount = 0;
    this.myPayCount = 0;
    this.myPrize = 0;
    this.leader = 0;
    this.refundAmount = 0;
    this.currentRank = 0;
    this.nick = '-';
    this.icon = '';
    this.frontMembers = '';
    this.frontPrize = '';
    this.totalPrize = 0;
    this.specName = '';
    this.tradeAmount = 0;
    this.packetCount = 0;
    this.packetAmount = 0;
  };

  // 查询移动端活动规则
  @action
  fetchActivityRule = async () => {
    try {
      const data = await HomeService.fetchActivityRule();
      if (data) {
        this.activityRule = data;
      }
    } catch (e) {
      console.log(e);
    }
  };

  // 获取团战活动规则
  @action
  fetchLeagueRule = async () => {
    try {
      const data = await HomeService.fetchLeagueRule();
      if (data) {
        this.activityRule = data;
      }
    } catch (e) {
      console.log(e);
    }
  };

  // 获取团战活动pk表格
  @action
  fetchLeagueTable = async () => {
    try {
      const data = await HomeService.fetchLeagueTable();
      if (data) {
        this.leagueList = data.map((item, ind) => {
          return {
            key: ind,
            title: item.title,
            desc: item.description,
            shareUrl: item.shareUrl,
          };
        });
      }
    } catch (e) {
      console.log(e);
    }
  };

  //查询PC活动规则
  @action
  fetchPCActivityRule = async () => {
    try {
      const data = await HomeService.fetchPCActivityRule();
      if (data) {
        this.pcActivityRule = data;
      }
    } catch (e) {
      console.log(e);
    }
  };

  //查询H5活动规则
  @action
  fetchH5DiscountRule = async () => {
    try {
      const data = await HomeService.fetchH5DiscountRule();
      if (data) {
        this.h5DiscountRule = data;
      }
    } catch (e) {
      console.log(e);
    }
  };

  // 阿里云云大使介绍
  @action
  fetchDashiRule = async () => {
    try {
      const data = await HomeService.fetchDashiRule();
      if (data) {
        this.dashiRule = data;
      }
    } catch (e) {
      console.log(e);
    }
  };

  // 没有红包和返回的规则介绍
  @action
  fetchRuleWithoutPacket = async () => {
    try {
      const data = await HomeService.fetchRuleWithoutPacket();
      if (data) {
        this.ruleWithoutPacket = data;
      }
    } catch (e) {
      console.log(e);
    }
  };
  @action
  fetchGroupRule = async () => {
    try {
      const data = await HomeService.fetchGroupRule();
      if (data) {
        this.groupRuleH5 = data;
      }
    } catch (e) {
      console.log(e);
    }
  };

  // 解散团
  @action
  disbandingGroup = async () => {
    try {
      const { data, code } = await DashboardService.disbandingGroup(this.groupCode);
      if (code == 200) {
        if (data) {
          toast({
            type: 'disbandingGroupSucc',
            callback: () => {
              hashHistory.replace('/');
            },
          });
        }
      } else {
        toast({ type: code });
      }
    } catch (e) {
      console.log(e);
    }
  };

  // 分页获取团成员列表
  @action
  async queryGroupMembers(params) {
    let results = await DashboardService.queryGroupMembers({ ...params });
    let { code, data } = results;
    if (code == '200') {
      let { datas, currentPage, totalCount, pageSize } = data;
      this.groupMembers = ransformArray(datas);
      this.pageInfo = { currentPage, totalCount, pageSize };
    }
  }

  // 分享页根据团code查询团信息
  @action
  getGroupInfo = async () => {
    const params = {
      groupCode: this.shareGroupCode,
    };
    await ShareService.getGroupInfo(params).then(results => {
      if (results.code == 200) {
        this.nick = results.data.nick;
        this.icon = results.data.icon;
        this.totalPayCount = results.data.totalPayCount;
        this.currentRank = results.data.currentRank;
      } else {
        if (results.code == '-110') {
          return;
        }
        toast({
          type: 'destroyTeam',
          callback: () => {
            hashHistory.replace('/');
          },
        });
      }
    });
  };

  // 获取红包信息
  @action
  async fetchMyPackageInfo() {
    try {
      let results = await TeamInfoService.fetchMyPackageInfo();
      const { code, data = [] } = results;
      if (code == 200) {
        if (data.length > 0) {
          let packageCountList = data.filter(item => Number(item.rebateStatus) === 0);
          this.myPackageList = packageCountList;
        } else {
          this.myPackageList = [];
        }
      } else {
        toast({ type: code });
      }
    } catch (e) {
      console.log(e);
    }
  }

  // 领取红包接口
  @action
  async fetchReceivePackage() {
    try {
      const myPackageList = this.myPackageList;
      if (myPackageList.length > 0) {
        let results = await TeamInfoService.fetchReceivePackage(myPackageList[myPackageList.length - 1].id);
        const { code, data = {} } = results;
        if (code == 200) {
          this.currentPackageCount = transformNumber(data.rebateAmount) / 100;
          this.myPackageList = myPackageList.slice(0, myPackageList.length - 1);
          this.packetCount = this.packetCount - 1;
          this.packetAmount = this.packetAmount + this.currentPackageCount;
          return true;
        } else {
          toast({ type: code });
          return false;
        }
      }
    } catch (e) {
      console.log(e);
    }
  }
  @action
  changeReceiveRedPackage = () => {
    this.showReceiveRedPackage = !this.showReceiveRedPackage;
  };

  @action
  async isendUnveilTime() {
    const endUnveil = '2018/11/13 9:00:00';
    const UnveilEnd = '2018/11/13 23:59:59';
    try {
      const isAfterStartTime = await Time.isAfter(endUnveil);
      const isAfterEndTime = await Time.isAfter(UnveilEnd);
      if (isAfterStartTime) {
        if (!isAfterEndTime) {
          this.ActivityTime = 'Unveil';
        } else {
          this.ActivityTime = 'activityOver';
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
  // 实名认证
  @observable
  openCertication = false;
  @observable
  certicationUrl = null;
  // 开启实名认证弹窗
  @action
  async toggleCertication() {
    this.openCertication = !this.openCertication;
    if (this.openCertication) {
      window.$ACE.Tracker.record('/aliyun.20181111.certication', 'EXP', '');
      const result = await DashboardService.fetchCerificationCode();
      this.certicationUrl = result.data.replace('http://', 'https://');
    } else {
      this.certicationUrl = null;
    }
  }
  @action
  checkCertification = async () => {
    const validateResult = await DashboardService.checkCertification();
    if (validateResult) {
      toast({
        type: 'validateSuccess',
      });
    } else {
      toast({
        type: 'validateError',
      });
    }
    this.toggleCertication();
  };
}
let dashboardStore = new DashboardStore();
export default dashboardStore;



// WEBPACK FOOTER //
// ./src/scripts/stores/DashboardStore.js